interface StreamURLInputProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  /** Yellow highlight + soft warning text; does not block submission. */
  warning?: string | null;
  /** Red highlight + error text; expected to block submission upstream. */
  error?: string | null;
}

export default function StreamURLInput({
  label,
  placeholder,
  value,
  onChange,
  disabled,
  warning,
  error,
}: StreamURLInputProps) {
  const hasError = error !== null && error !== undefined && error !== '';
  const hasWarning = !hasError && warning !== null && warning !== undefined && warning !== '';

  const borderClass = hasError
    ? 'border-red-500 dark:border-red-500'
    : hasWarning
      ? 'border-yellow-500 dark:border-yellow-500 bg-yellow-50 dark:bg-yellow-900/20'
      : 'border-gray-300 dark:border-gray-600';

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
        {label}
      </label>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled === true}
        className={`w-full px-3 py-2 text-sm rounded-lg border bg-white dark:bg-gray-700 text-gray-900 dark:text-white disabled:opacity-50 ${borderClass}`}
      />
      {hasError && (
        <p className="text-xs text-red-500 mt-1">{error}</p>
      )}
      {hasWarning && (
        <p className="text-xs text-yellow-600 dark:text-yellow-400 mt-1">{warning}</p>
      )}
    </div>
  );
}
